export interface AppSpecs {
  'specs.funnel.StudioTemplatesSkipStyle': 'true' | 'false';
  'specs.funnel.StudioTemplatesNewTitle': 'true' | 'false';
  'specs.funnel.StudioTemplatesNewLayout': 'true' | 'false';
  'specs.funnel.StudioTemplatesTryBlankCanvasButton': 'true' | 'false';
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'true' | 'false';
  'specs.funnel.StudioGalleryInspirationalTemplates': 'true' | 'false';
  'specs.funnel.StudioTemplatesTemplateLazyLoading': 'true' | 'false';
  'specs.funnel.StudioTemplatesHideBlankCanvasTemplateOnMobile':
    | 'true'
    | 'false';
  'specs.funnel.StudioTemplatesSearchInput': 'true' | 'false';
  'specs.funnel.StudioTemplatesPreviewTemplateMobile': 'true' | 'false';
}

export const defaultAppSpecValues: AppSpecs = {
  'specs.funnel.StudioTemplatesSkipStyle': 'false',
  'specs.funnel.StudioTemplatesNewTitle': 'false',
  'specs.funnel.StudioTemplatesNewLayout': 'false',
  'specs.funnel.StudioTemplatesTryBlankCanvasButton': 'false',
  'specs.funnel.StudioTemplatesHideBlankCanvasTemplateOnMobile': 'false',
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'false',
  'specs.funnel.StudioGalleryInspirationalTemplates': 'false',
  'specs.funnel.StudioTemplatesTemplateLazyLoading': 'false',
  'specs.funnel.StudioTemplatesSearchInput': 'false',
  'specs.funnel.StudioTemplatesPreviewTemplateMobile': 'false',
};
